import React from 'react';
import PropTypes from 'prop-types';
import { Select } from '@ferris/react/components/forms';

const noop = () => {};

function FlagDropdown({
    countryCode, id, items, onChange, phoneCode
}) {
    return (
        <div className="select-drop-down">
            <Select
                formControlProps={
                    { id: `${id}` }
                }
                classes="InputTel__select"
                name={id}
                optionList={items}
                value={countryCode}
                onChange={onChange}
            />
            <span className="InputTel__phone-code">{`+${phoneCode}`}</span>
        </div>
    );
}

FlagDropdown.propTypes = {
    countryCode: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
    items: PropTypes.arrayOf(
        PropTypes.shape({
            value: PropTypes.string,
            label: PropTypes.string
        })
    ).isRequired,
    onChange: PropTypes.func,
    phoneCode: PropTypes.string.isRequired
};

FlagDropdown.defaultProps = {
    onChange: noop
};

export default FlagDropdown;
